import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
// import styled from "@emotion/styled";
import { useState, useEffect, ChangeEvent } from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  IconButton,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Modal,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { fontTheme, insertLineBreaks } from "../common/utils";
import CloseIcon from "@mui/icons-material/Close";

const modal = css`
  margin: 64px auto;
  @media screen and (min-width: 1194px) {
    width: 80%;
  }
  @media screen and (min-width: 1366px) {
    width: 70%;
  }
`;
const modalContent = css`
  position: relative;
`;

const closeButton = css`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 100;
`;
const card = css`
  padding: 8px;
  display: flex;
  flex-direction: row;
`;
const table = css`
  border-collapse: collapse;
  width: 350px;
`;
const secondTable = css`
  position: sticky;
  left: 350px;
  border-collapse: collapse;
  width: 450px;
`;
const thirdTable = css`
  position: sticky;
  left: 800px;
  border-collapse: collapse;
  width: 100px;
`;
const tableContainer = css`
  width: 350px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
`;
const secondTableContainer = css`
  width: 400px;
  max-height: 400px;
  overflow-x: hidden;
`;
const thirdTableContainer = css`
  width: 100px;
  max-height: 400px;
  overflow-x: hidden;
`;
const headerCell = css`
  width: 350px;
  height: 40px;
  border: none;
  padding: 8px;
  background-color: #e0ffee;
  align-items: center;
  z-index: 10;
`;
const buttonCell = css`
  position: sticky;
  top: 70px;
  z-index: 10;
`;
const secondHeaderCell = css`
  width: 400px;
  height: 40px;
  border: none;
  padding: 8px;
  background-color: #e0ffee;
  align-items: center;
`;
const thirdHeaderCell = css`
  width: 100px;
  height: 40px;
  border: 1px solid #ccc;
  border: none;
  align-items: center;
`;
const accordion = css`
  cursor: pointer;
  padding: 8px;
  border: none;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;
const rowBorder = css`
  width: 350px;
  height: 70px;
  border: none;
`;
const secondRowBorder = css`
  width: 370px;
  height: 70px;
  border: none;
`;
const thirdRowBorder = css`
  position: sticky;
  top: 0px;
  border: none;
`;
const rowFlex = css`
  align-items: center;
  display: flex;
`;
const infoCheckBox = css`
  align-items: center;
  display: flex;
  flex-direction: column;
`;
const infoCheckBoxItem = css`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

const infoCheckBoxText = css`
  margin-left: 8px;
  width: 150px;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const designButton = css`
  border: 2px solid #00cc5b;
  background-color: white;
  color: black;
  border-radius: 20px;
  padding: 5px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
const formControlLabelStyle = css`
  margin: 0;
  border-radius: 4px;
  padding: 8px 8px 8px 0px;
  border: none;
`;
const radioStyle = (value: string, checked: boolean) => ({
  color: checked ? "#00CC5B" : "#ccc",
  "&.Mui-checked": {
    color: "#00CC5B",
  },
});

type PMASortModalProps = {
  onConfirm: (
    selected: string[],
    tobaccoFlag: boolean,
    reservationFlag: boolean,
    specialFlag: boolean,
    smsFlag: boolean,
    value: string
  ) => void;
  storePmaAllList: any[];
  storePmaData: any[];
  selectedItems: any[];
  isInitial: boolean;
  tobaccoFlag: boolean;
  onTobaccoFlagChange: (flag: boolean) => void;
  reservationFlag: boolean;
  specialFlag: boolean;
  smsFlag: boolean;
  value: string;
  setTobaccoFlag: (flag: boolean) => void;
  setReservationFlag: (flag: boolean) => void;
  setSpecialFlag: (flag: boolean) => void;
  setSmsFlag: (flag: boolean) => void;
  setValue: (value: string) => void;
  onClose: () => void;
  onInitialize: () => void;
};

const PMASortModal: React.FC<PMASortModalProps> = ({
  onConfirm,
  onInitialize,
  storePmaAllList,
  storePmaData,
  selectedItems,
  isInitial,
  tobaccoFlag,
  onTobaccoFlagChange,
  reservationFlag,
  specialFlag,
  smsFlag,
  setTobaccoFlag,
  setReservationFlag,
  setSpecialFlag,
  setSmsFlag,
  value,
  setValue,
  onClose,
}) => {
  const [checkedInfo, setCheckedInfo] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const [checkedPMA, setCheckedPMA] = useState<{ [key: string]: boolean }>({});
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue("choice");
    const initialCheckedInfo: { [key: string]: boolean } = {};
    if (storePmaData && storePmaAllList) {
      const pmaCds = storePmaAllList
        .map((data: any) => data.pma_cd)
        .filter((value, index, self) => self.indexOf(value) === index);

      if (isInitial || (selectedItems && selectedItems.length === 0)) {
        // isInitialがtrueかselectedItemsが空の場合、すべてチェック
        storePmaAllList.forEach((data: any) => {
          const key = `${data.pma_cd}_${data.info_cd}`;
          initialCheckedInfo[key] = true;
        });
        pmaCds.forEach((pmaKey: string) => {
          initialCheckedInfo[pmaKey] = true;
        });
        setTobaccoFlag(true);
        setReservationFlag(true);
        setSpecialFlag(true);
        setSmsFlag(true);
      } else {
        storePmaAllList.forEach((data: any) => {
          const key = `${data.pma_cd}_${data.info_cd}`;
          initialCheckedInfo[key] = selectedItems.includes(key);
        });

        pmaCds.forEach((pmaKey: string) => {
          initialCheckedInfo[pmaKey] = selectedItems.some((item) =>
            item.startsWith(`${pmaKey}_`)
          );
        });
      }
      setCheckedInfo(initialCheckedInfo);
    }
  }, [storePmaData, storePmaAllList, selectedItems, isInitial]);

  useEffect(() => {
    // tobaccoFlag の変更時に "61" と関連するチェックボックスの状態を更新
    setCheckedInfo((prevState) => {
      const newState = { ...prevState };
      storePmaAllList.forEach((data: any) => {
        if (data.pma_cd === "61") {
          newState[data.pma_cd] = !tobaccoFlag;
          newState[`${data.pma_cd}_${data.info_cd}`] = !tobaccoFlag;
        }
      });
      return newState;
    });
  }, [tobaccoFlag, storePmaAllList]);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  // selectedValueがdailyかnon_dailyに変更されたときに、checkedInfoを更新する
  useEffect(() => {
    if (selectedValue === "daily") {
      // selectedValueが1の場合、デイリー商品にチェックを入れる
      handleSelectDaily();
    } else if (selectedValue === "non_daily") {
      // selectedValueが2の場合、非デイリー商品にチェックを入れる
      handleSelectNonDaily();
    }
  }, [selectedValue]);

  const handleConfirm = () => {
    const selectedPmaCdInfoCd = Object.keys(checkedInfo)
      .filter((key) => checkedInfo[key])
      .filter((key) => key.includes("_"));
    onConfirm(
      selectedPmaCdInfoCd,
      tobaccoFlag,
      reservationFlag,
      specialFlag,
      smsFlag,
      selectedValue
    );
  };

  // 初期状態に戻す
  const handleInitialize = () => {
    const newCheckedInfo: { [key: string]: boolean } = {};
    if (storePmaAllList) {
      storePmaAllList.forEach((data: any) => {
        newCheckedInfo[`${data.pma_cd}_${data.info_cd}`] = true;
        newCheckedInfo[data.pma_cd] = true;
      });
      setCheckedInfo(newCheckedInfo);
    }
    setSelectedValue("choice");
    setTobaccoFlag(false);
    setReservationFlag(true);
    setSpecialFlag(true);
    setSmsFlag(true);
    onInitialize();
  };

  // デイリー商品にチェックを入れる
  const handleSelectDaily = () => {
    const newCheckedInfo: { [key: string]: boolean } = {};
    const pmaStatus: { [pma_cd: string]: boolean } = {};
    storePmaAllList.forEach((data: any) => {
      const key = `${data.pma_cd}_${data.info_cd}`;
      const pmaKey = data.pma_cd;
      // daily が 0 かつ non_daily が 1 の場合に true を設定
      if (data.daily === "0" && data.non_daily === "1") {
        newCheckedInfo[key] = true;
      } else {
        newCheckedInfo[key] = false;
      }
      // pma の状態を更新
      pmaStatus[pmaKey] = pmaStatus[pmaKey] || newCheckedInfo[key];
    });
    for (const pmaKey in pmaStatus) {
      newCheckedInfo[pmaKey] = pmaStatus[pmaKey];
    }
    setCheckedInfo(newCheckedInfo);
  };

  // 非デイリー商品にチェックを入れる
  const handleSelectNonDaily = () => {
    const newCheckedInfo: { [key: string]: boolean } = {};
    const pmaStatus: { [pma_cd: string]: boolean } = {};
    storePmaAllList.forEach((data: any) => {
      const key = `${data.pma_cd}_${data.info_cd}`;
      const pmaKey = data.pma_cd;
      // non_daily が "1" でない場合に true を設定
      if (data.non_daily !== "1") {
        newCheckedInfo[key] = true;
      } else {
        newCheckedInfo[key] = false;
      }
      // pma の状態を更新
      pmaStatus[pmaKey] = pmaStatus[pmaKey] || newCheckedInfo[key];
    });
    for (const pmaKey in pmaStatus) {
      newCheckedInfo[pmaKey] = pmaStatus[pmaKey];
    }
    setCheckedInfo(newCheckedInfo);
  };

  // クリアボタンを押した際にチェック全部外す
  const handleClear = () => {
    const initialCheckedInfo: { [key: string]: boolean } = {};
    storePmaAllList.forEach((data: any) => {
      initialCheckedInfo[`${data.pma_cd}_${data.info_cd}`] = false;
      initialCheckedInfo[data.pma_cd] = false;
    });
    setCheckedInfo(initialCheckedInfo);
    setSelectedValue("choice");
    setTobaccoFlag(true);
  };

  const handleExcludeTobacco = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setTobaccoFlag(isChecked);
    onTobaccoFlagChange(event.target.checked);
    if (selectedValue === "daily") {
      setSelectedValue("choice");
    }
  };
  const handleExcludeReservation = (event: ChangeEvent<HTMLInputElement>) => {
    setReservationFlag(event.target.checked);
    if (selectedValue !== "choice") {
      setSelectedValue("choice");
    }
  };
  const handleExcludeSpecial = (event: ChangeEvent<HTMLInputElement>) => {
    setSpecialFlag(event.target.checked);
    if (selectedValue !== "choice") {
      setSelectedValue("choice");
    }
  };
  const handleExcludeSms = (event: ChangeEvent<HTMLInputElement>) => {
    setSmsFlag(event.target.checked);
    if (selectedValue !== "choice") {
      setSelectedValue("choice");
    }
  };

  // pma_cd、info_cdが重複しないmodalに表示するオブジェクトの作成
  const groupedData = storePmaAllList.reduce((acc: any, item: any) => {
    if (!acc[item.pma_cd]) {
      acc[item.pma_cd] = {
        pma_cd: item.pma_cd,
        pma_name: item.pma_name,
        infos: [],
      };
    }
    const infoExists = acc[item.pma_cd].infos.some(
      (info: any) => info.info_cd === item.info_cd
    );
    if (!infoExists) {
      acc[item.pma_cd].infos.push({
        info_cd: item.info_cd,
        info_name: item.info_name,
      });
    }
    return acc;
  }, {});

  // ソート処理を追加
  const sortedGroupedData = Object.values(groupedData).sort(
    (a: any, b: any) => {
      return a.pma_cd.localeCompare(b.pma_cd); // PMA (pma_cd) でソート
    }
  );

  sortedGroupedData.forEach((group: any) => {
    group.infos.sort((a: any, b: any) => {
      return a.info_cd.localeCompare(b.info_cd); // 情報分類 (info_cd) でソート
    });
  });

  // アコーディオン制御
  const handleAccordionClick = (pma_cd: string) => {
    setOpenAccordion(openAccordion === pma_cd ? null : pma_cd);
  };

  // pmaのチェックボックスが選択された場合、配下のinfoのチェックボックスを制御
  const handlePmaCheckboxChange = (pma_cd: string) => {
    const isChecked = !checkedInfo[pma_cd];
    setCheckedInfo((prevState: any) => {
      const newState = { ...prevState, [pma_cd]: isChecked };
      storePmaAllList
        .filter((data: any) => data.pma_cd === pma_cd)
        .forEach((data: any) => {
          newState[`${pma_cd}_${data.info_cd}`] = isChecked;
        });
      if (pma_cd === "61") {
        setTobaccoFlag(!isChecked);
      }
      return newState;
    });
    // selectedValue が "choice" 以外の場合に、setSelectedValue("choice") を実行
    if (selectedValue !== "choice") {
      setSelectedValue("choice");
    }
  };

  const handleInfoCheckboxChange = (pma_cd: string, info_cd: string) => {
    setCheckedInfo((prevState: any) => {
      const newState = {
        ...prevState,
        [`${pma_cd}_${info_cd}`]: !prevState[`${pma_cd}_${info_cd}`],
      };
      const relatedInfoItems = storePmaAllList.filter(
        (d: any) => d.pma_cd === pma_cd
      );
      const isAnyInfoChecked = relatedInfoItems.some(
        (d: any) => newState[`${pma_cd}_${d.info_cd}`]
      );
      newState[pma_cd] = isAnyInfoChecked;
      if (pma_cd === "61") {
        const relatedInfoItems = storePmaAllList.filter(
          (d: any) => d.pma_cd === pma_cd
        );
        const isAnyInfoChecked = relatedInfoItems.some(
          (d: any) => newState[`${pma_cd}_${d.info_cd}`]
        );
        setTobaccoFlag(!isAnyInfoChecked);
      }
      return newState;
    });
    // selectedValue が "choice" 以外の場合に、setSelectedValue("choice") を実行
    if (selectedValue !== "choice") {
      setSelectedValue("choice");
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
    setCheckedPMA({ ...checkedPMA, [event.target.name]: event.target.checked });
    //  "61"のチェック状態をtobaccoFlagに反映する
    if (event.target.name === "61") {
      setTobaccoFlag(event.target.checked);
    }
  };

  return (
    <>
      <ThemeProvider theme={fontTheme()}>
        <Modal open={true} onClose={onClose}>
          <Card css={modal}>
            <div css={modalContent}>
              <IconButton onClick={onClose} size={"small"} css={closeButton}>
                <CloseIcon />
              </IconButton>
              <CardContent css={card}>
                <TableContainer css={tableContainer}>
                  <Table stickyHeader css={table}>
                    <TableHead style={{ height: "75px" }}>
                      <TableRow css={rowBorder}>
                        <TableCell css={headerCell}>PMA・情報分類</TableCell>
                      </TableRow>
                      <TableRow css={[rowBorder,buttonCell]}>
                        <TableCell>
                          <Button onClick={handleInitialize} css={designButton}>
                            初期化
                          </Button>
                          <Button onClick={handleClear} css={designButton}>
                            クリア
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow css={rowBorder}>
                        <TableCell rowSpan={2}>
                          {sortedGroupedData.map((group: any) => (
                            <div key={group.pma_cd}>
                              <div
                                css={accordion}
                                onClick={() =>
                                  handleAccordionClick(group.pma_cd)
                                }
                              >
                                <IconButton
                                  onClick={() =>
                                    handleAccordionClick(group.pma_cd)
                                  }
                                >
                                  {openAccordion === group.pma_cd ? (
                                    <ExpandLess />
                                  ) : (
                                    <ExpandMore />
                                  )}
                                </IconButton>
                                <Checkbox
                                  checked={!!checkedInfo[group.pma_cd]}
                                  onChange={() =>
                                    handlePmaCheckboxChange(group.pma_cd)
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ color: "#00cc5b" }}
                                />
                                {group.pma_name}
                              </div>
                              {openAccordion === group.pma_cd && (
                                <div css={infoCheckBox}>
                                  {group.infos.map((info: any) => (
                                    <div
                                      key={info.info_cd}
                                      css={infoCheckBoxItem}
                                    >
                                      <Checkbox
                                        checked={
                                          !!checkedInfo[
                                            `${group.pma_cd}_${info.info_cd}`
                                          ]
                                        }
                                        onChange={() =>
                                          handleInfoCheckboxChange(
                                            group.pma_cd,
                                            info.info_cd
                                          )
                                        }
                                        style={{ color: "#00cc5b" }}
                                      />
                                      <span css={infoCheckBoxText}>
                                        {insertLineBreaks(info.info_name, 7)}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer css={secondTableContainer}>
                  <Table stickyHeader css={secondTable}>
                    <TableHead style={{ width: "400px" }}>
                      <TableRow css={secondRowBorder}>
                        <TableCell css={secondHeaderCell}>
                          デイリー/非デイリー
                        </TableCell>
                      </TableRow>
                      <TableRow css={secondRowBorder}>
                        <TableCell style={{ padding: "8px" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={tobaccoFlag}
                                onChange={handleExcludeTobacco}
                                name="tobaccoFlag"
                                style={{
                                  color: "#00cc5b",
                                }}
                              />
                            }
                            label="煙草除く"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={reservationFlag}
                                onChange={handleExcludeReservation}
                                name="reservationFlag"
                                style={{
                                  color: "#00cc5b",
                                }}
                              />
                            }
                            label="予約除く"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={specialFlag}
                                onChange={handleExcludeSpecial}
                                name="specialFlag"
                                style={{
                                  color: "#00cc5b",
                                }}
                              />
                            }
                            label="特発除く"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={smsFlag}
                                onChange={handleExcludeSms} //SMS用の処理を追加する
                                name="smsFlag"
                                style={{
                                  color: "#00cc5b",
                                }}
                              />
                            }
                            label="SMS除く"
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow css={secondRowBorder}>
                        <RadioGroup
                          value={selectedValue}
                          onChange={handleChange}
                          row
                        >
                          <FormControlLabel
                            value="choice"
                            control={
                              <Radio
                                sx={radioStyle(
                                  "choice",
                                  selectedValue === "choice"
                                )}
                              />
                            }
                            label="カスタマイズ"
                            css={formControlLabelStyle}
                          />
                          <FormControlLabel
                            value="daily"
                            control={
                              <Radio
                                sx={radioStyle(
                                  "daily",
                                  selectedValue === "daily"
                                )}
                              />
                            }
                            label="デイリー"
                            css={formControlLabelStyle}
                          />
                          <FormControlLabel
                            value="non_daily"
                            control={
                              <Radio
                                sx={radioStyle(
                                  "non_daily",
                                  selectedValue === "non_daily"
                                )}
                              />
                            }
                            label="非デイリー"
                            css={formControlLabelStyle}
                          />
                        </RadioGroup>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer css={thirdTableContainer}>
                  <Table css={thirdTable}>
                    <TableCell
                      css={[rowFlex, thirdRowBorder, thirdHeaderCell]}
                    >
                      <Button onClick={handleConfirm} css={designButton}>
                        決定
                      </Button>
                    </TableCell>
                  </Table>
                </TableContainer>
              </CardContent>
            </div>
          </Card>
        </Modal>
      </ThemeProvider>
    </>
  );
};
export default PMASortModal;
